import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const convertDateToInputFormat = (dateStr) => {
  if (!dateStr) return "";

  const [day, monthStr, year] = dateStr.split("-");
  const monthMap = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  const month = monthMap[monthStr];
  if (!month) return "";

  return `${year}-${month}-${day.padStart(2, "0")}`;
};

export const blockingColumns = (setModalData) => [
  {
    Header: "Hotel Name",
    accessor: "hotelName",
  },

  {
    Header: "Blocked Rooms",
    accessor: "BlockRooms",
  },

  {
    Header: "Block From",
    accessor: "blockFromDate",
  },
  {
    Header: "Block To",
    accessor: "blockToDate",
  },
  {
    Header: "Customer Name",
    accessor: "customerName",
  },
  {
    Header: "Room Type",
    accessor: "RoomTypeName",
  },
  {
    Header: "Remarks",
    accessor: "Remarks",
  },
  {
    Header: "View",
    accessor: "view",
    Cell: ({ row }) => {
      const bookingRef = row.original.BookingRefNo;
      const handleViewClick = () => {
        window.open(`/view-settlement_details/${bookingRef}`, "_blank");
      };

      return (
        <button
          style={{
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            width: "90px",
            padding: "4px 8px",
            margin: "0px auto",
          }}
          onClick={handleViewClick}
        >
          View
        </button>
      );
    },
  },
  {
    Header: "Update",
    accessor: "updateBlock",
    Cell: ({ row }) => {
      
      const handleOpenModal = () => {
        const modalObj = {
          ...row.original,
          blockRoomId: row.original.BookingRefNo || "",
          blockFromDate: convertDateToInputFormat(row.original.blockFromDate),
          blockToDate: convertDateToInputFormat(row.original.blockToDate),
          totalRooms: row.original.TotalRooms || "",
        };

        setModalData({
          show: true,
          data: modalObj,
        });
      };
      return (
        <button
          style={{
            backgroundColor: "#6f42c1",
            color: "white",
            border: "none",
            borderRadius: "4px",
            width: "90px",
            padding: "4px 8px",
            margin: "0px auto",
          }}
          onClick={handleOpenModal}
        >
          Edit
        </button>
      );
    },
  },

  {
    Header: "Action",
    accessor: "action",
    Cell: ({ row }) => {
      const bookingRef = row.original.BookingRefNo;
      const ReleaseBlocked = async () => {
        try {
          console.log("Release Blocked", bookingRef);
          const response = await axios.post(
            `${REACT_APP_API_URL}api/dashboard/admin/room-blocking/release`,
            { bookingRef }
          );
          console.log("Release Blocked Response", response);
          if (response.status === 200) {
            alert("Blocked Room Released Successfully");
            window.location.reload();
          } else {
            alert("Failed to release blocked room");
          }
        } catch (error) {
          console.error("Error releasing blocked room:", error);
          alert("Error releasing blocked room");
        }
      };

      return (
        <button
          style={{
            backgroundColor: "#ff7f50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            width: "90px",
            padding: "4px 8px",
            margin: "0px auto",
          }}
          onClick={ReleaseBlocked}
        >
          Release
        </button>
      );
    },
  },
];
